// import sparkMd5 from 'spark-md5'
import { addSignature } from 'Src/util/request-signature'
import url from 'Src/util/url'

// trace平台添加公共log参数
function setTraceLogCookie () {
  $.removeCookie('trace_log_adv_id', { domain: '.oceanengine.com', path: '/' })
  $.removeCookie('trace_log_user_id', { domain: '.oceanengine.com', path: '/' })
  $.cookie('trace_log_adv_id',
    window.GLOBAL_VAR && GLOBAL_VAR.advertiser ? GLOBAL_VAR.advertiser.id : '',
    { domain: '.oceanengine.com', path: '/' })
  $.cookie('trace_log_user_id',
    window.GLOBAL_VAR && (GLOBAL_VAR.staff || GLOBAL_VAR.coreUser) ? (GLOBAL_VAR.staff.id || GLOBAL_VAR.coreUser.id || '') : '',
    { domain: '.oceanengine.com', path: '/' })
}
// 页面进入时设置trace_log cookie 保证路由记录正确
setTraceLogCookie()

// const token = sparkMd5.hash(`${new Date().getTime()}${Math.random().toString(36).substr(2)}`)
const RESPONSE_CODE = {
  0: {
    text: '成功'
  },
  40000: {
    text: '参数错误'
  },
  40001: {
    text: '未登录'
  },
  40002: {
    text: '权限错误'
  },
  40003: {
    text: '数据不存在'
  },
  50000: {
    text: '系统错误'
  },
  50001: {
    text: '系统维护'
  },
  50002: {
    text: '未知错误'
  },
  50100: {
    text: '内部服务错误'
  },
  50101: {
    text: '内部服务超时'
  },
  50102: {
    text: '内部服务错误'
  },
  100000: {
    text: '评论更新失败'
  },
  100001: {
    text: '广告没有推广的内容，操作失败'
  },
  100002: {
    text: '非抖音评论'
  },
  100003: {
    text: '查询的结束时间必须晚于开始时间'
  },
  100004: {
    text: '系统异常，暂时只支持查看单条计划'
  },
  100005: {
    text: '单次查询数量超过限制'
  }
}
$.ajaxSetup({
  cache: false,
  dataType: 'json',
  beforeSend: function (xhr, settings) {
    if (!(/^http:.*/.test(settings.url) || /^https:.*/.test(settings.url))) {
      // 只给相对路径加X-CSRFToken，避免外部接口因为加上特殊Header，被处理成了非简单请求、需要发送预检请求
      xhr.setRequestHeader('X-CSRFToken', $.cookie('csrftoken'))
      // 增加当前tab唯一表示,用于后端埋点
      xhr.setRequestHeader('X-SessionId', window.sessionId || '')
    }
    // xhr.setRequestHeader('Authorization', token) // 后端用来防重复点击
    // }
    // 请求前重置trace_log cookie确保一致性
    setTraceLogCookie()
    settings.url = url.updateQueryWithAdvid(settings.url) // 一户多开：接口请求前增加adv_id
    settings.url = addSignature(settings) // 风控: 人机识别
  }
})
// 通用成功处理
$(document).ajaxSuccess(function (event, jqxhr, settings) {
  // 针对不同状态码处理
  if (jqxhr && jqxhr.responseJSON && jqxhr.responseJSON.code !== undefined) {
    switch (jqxhr.responseJSON.code) {
      case 0:
        break
      // 40001 未登录特殊处理
      case 40001:
        if (jqxhr.responseJSON.extra && jqxhr.responseJSON.extra.redirect_url) {
          window.location.href = jqxhr.responseJSON.extra.redirect_url
        }
        break
      // 40102 无此操作权限
      case 40102:
        (new Vue()).$message('无此操作权限', 'error')
        break
      // 其余错误码处理逻辑
      default:
        console.log(settings.url, 'Error Code', jqxhr.responseJSON.code, 'Error Msg', jqxhr.responseJSON.msg || RESPONSE_CODE[jqxhr.responseJSON.code])
    }
  }
})

$(document).ajaxError(function (event, jqxhr, settings) {
  // 针对不同状态码处理
  if (jqxhr && jqxhr.responseJSON && jqxhr.responseJSON.code !== undefined) {
    switch (jqxhr.responseJSON.code) {
      case 0:
        break
      // 40001 未登录特殊处理
      case 40001:
        if (jqxhr.responseJSON.extra && jqxhr.responseJSON.extra.redirect_url) {
          window.location.href = jqxhr.responseJSON.extra.redirect_url
        }
        break
      // 40102 无此操作权限
      case 40102:
        (new Vue()).$message('无此操作权限', 'error')
        break
      // 其余错误码处理逻辑
      default:
        console.log(settings.url, 'Error Code', jqxhr.responseJSON.code, 'Error Msg', jqxhr.responseJSON.msg || RESPONSE_CODE[jqxhr.responseJSON.code])
    }
  }
})

const userObj = window.GLOBAL_VAR || {}
const STATUS = {
  401: {
    text: '您没有权限操作'
  },
  403: {
    text: '您没有权限操作'
  },
  404: {
    text: '当前资源不存在'
  },
  500: {
    text: '系统异常，请稍后重试'
  }
}

BUI.fetch2 = function (config) {
  if (config.success) {
    const successFun = config.success
    config.success = function (resp) {
      if (resp.status === 'success') {
        successFun(resp)
      } else {
        config.error(resp)
      }
    }
  }
  return BUI.fetch(config)
}

BUI.fetch = function (config) {
  if ($ && $.prototype.jquery) {
    return $.ajax($.extend({
      method: 'GET',
      error: function (resp) {
        // /* eslint-disable no-undef */
        window.TA('track', 'fetch_error', {
          advertiser_id: (userObj.advertiser && userObj.advertiser.id) || 0,
          url: config.url || 'unknown',
          status: resp.status === undefined ? 600 : resp.status === undefined,
          referer: window.location.href
        });
        (new Vue()).$message(STATUS[resp.status] ? STATUS[resp.status].text : '网络异常，请刷新重试~', 'error')
      }
    }, config))
  }
}

BUI.update = function (config) {
  if ($ && $.prototype.jquery) {
    return $.ajax($.extend({
      method: 'POST',
      error: function (resp) {
        /* eslint-disable no-undef */
        window.TA('track', 'update_error', {
          advertiser_id: (userObj.advertiser && userObj.advertiser.id) || 0,
          url: config.url || 'unknown',
          status: resp.status === undefined ? 600 : resp.status === undefined,
          referer: window.location.href
        });
        (new Vue()).$message(STATUS[resp.status] ? STATUS[resp.status].text : '网络异常，请刷新重试~', 'error')
      }
    }, config))
  }
}
BUI.ajax = $.ajax
